import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4763e87a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "mt-md-5 mt-3",
  key: "calender-view"
}
const _hoisted_2 = {
  key: "service-view",
  class: "mt-md-0 mt-3"
}
const _hoisted_3 = {
  key: "persons-view",
  class: "mt-md-0 mt-3"
}
const _hoisted_4 = {
  key: "summary-view",
  class: "mt-md-0 mt-3"
}
const _hoisted_5 = {
  key: "success-view",
  class: "mt-md-0 mt-3"
}

export function render(_ctx: any,_cache: any) {
  const _component_StepNav = _resolveComponent("StepNav")!
  const _component_CalendarView = _resolveComponent("CalendarView")!
  const _component_ServiceView = _resolveComponent("ServiceView")!
  const _component_PersonsView = _resolveComponent("PersonsView")!
  const _component_SummaryView = _resolveComponent("SummaryView")!
  const _component_SuccessView = _resolveComponent("SuccessView")!
  const _component_FullscreenModal = _resolveComponent("FullscreenModal")!

  return (_openBlock(), _createBlock(_component_FullscreenModal, {
    stepViews: _ctx.stepViews,
    step: _ctx.step,
    onAddToCart: _ctx.onAddToCart,
    "button-config": _ctx.buttonConfig,
    onClose: _ctx.onCloseModal,
    "trigger-tracking": true
  }, {
    default: _withCtx(() => [
      _createVNode(_component_StepNav, {
        steps: _ctx.steps,
        step: _ctx.step,
        stepViews: _ctx.stepViews,
        hideServiceView: _ctx.hideServiceView,
        onChangeStep: _ctx.onChangeStep
      }, null, 8, ["steps", "step", "stepViews", "hideServiceView", "onChangeStep"]),
      (_ctx.stepViews[_ctx.step] === 'calendar')
        ? (_openBlock(), _createBlock(_Transition, {
            key: 0,
            name: "fade",
            appear: ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("section", _hoisted_1, [
                _createVNode(_component_CalendarView, {
                  title: _ctx.title,
                  "ticket-id": _ctx.ticketId,
                  isAnnualPass: _ctx.isAnnualPass
                }, null, 8, ["title", "ticket-id", "isAnnualPass"])
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.stepViews[_ctx.step] === 'services')
        ? (_openBlock(), _createBlock(_Transition, {
            key: 1,
            name: "fade",
            appear: ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("section", _hoisted_2, [
                _createVNode(_component_ServiceView, {
                  stepViews: _ctx.stepViews,
                  title: _ctx.title,
                  ticketId: _ctx.ticketId
                }, null, 8, ["stepViews", "title", "ticketId"])
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.stepViews[_ctx.step] === 'persons')
        ? (_openBlock(), _createBlock(_Transition, {
            key: 2,
            name: "fade"
          }, {
            default: _withCtx(() => [
              _createElementVNode("section", _hoisted_3, [
                _createVNode(_component_PersonsView, {
                  stepViews: _ctx.stepViews,
                  title: _ctx.title,
                  ticketId: _ctx.ticketId,
                  isLoggedIn: _ctx.isLoggedIn
                }, null, 8, ["stepViews", "title", "ticketId", "isLoggedIn"])
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.stepViews[_ctx.step] === 'summary')
        ? (_openBlock(), _createBlock(_Transition, {
            key: 3,
            name: "fade"
          }, {
            default: _withCtx(() => [
              _createElementVNode("section", _hoisted_4, [
                _createVNode(_component_SummaryView, {
                  stepViews: _ctx.stepViews,
                  title: _ctx.title,
                  ticketId: _ctx.ticketId,
                  hasServiceView: _ctx.hasServiceView
                }, null, 8, ["stepViews", "title", "ticketId", "hasServiceView"])
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.step === _ctx.stepViews.length)
        ? (_openBlock(), _createBlock(_Transition, {
            key: 4,
            name: "fade"
          }, {
            default: _withCtx(() => [
              _createElementVNode("section", _hoisted_5, [
                _createVNode(_component_SuccessView, {
                  stepViews: _ctx.stepViews,
                  title: _ctx.title,
                  ticketId: _ctx.ticketId,
                  successData: _ctx.successData,
                  isLoading: _ctx.isLoading
                }, null, 8, ["stepViews", "title", "ticketId", "successData", "isLoading"])
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["stepViews", "step", "onAddToCart", "button-config", "onClose"]))
}